import { captureException } from '@sentry/browser';

type TrackingSource =
  | 'record_hit'
  | 'profile_measurement'
  | 'page_activity'
  | 'analytics_landing';
const reportedSources = new Set<TrackingSource>();

export async function observeTrackingDelivery(
  source: TrackingSource,
  deliver: () => Promise<Response | void> | void,
): Promise<void> {
  try {
    const response = await deliver();
    if (response && !response.ok) {
      throw new Error(`Tracking request failed (HTTP ${response.status})`);
    }
  } catch (error) {
    // Keep the cap across SPA navigation and BFCache restores.
    if (reportedSources.has(source)) return;
    reportedSources.add(source);
    try {
      captureException(
        error instanceof Error ? error : new Error(String(error)),
        {
          tags: { tracking_source: source },
        },
      );
    } catch {
      // Reporting failures must not interrupt navigation.
    }
  }
}
